export { RelationshipsReportTable } from './Table'
